export class Tercero {
    id: number;
    nombres: string;
    apellidos: string;
    idTipoDePersona: number;
    idTipoDeIdentificacion: number;
    numeroIdentificacion: string;
}